import { useState, useEffect } from "react";
// --------------------- Import Services ---------------------
import { reservaService } from "../services/reservaService";
import { Reserva } from "../interfaces/Reserva";

// --------------------- Import Interfaces ---------------------
//import { DataTypeReserva } from "../interfaces/DataTypeReserva";
export const useReservas = () => {
  const [reservas, setReservas] = useState<Reserva[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchReservas = async () => {
      const data = await reservaService();
      setReservas(data);
      setIsLoading(false);
    };

    fetchReservas();
  }, []);

  return { reservas, isLoading };
};
